import { executeStandardRequest, type MusinsaStandardResponse } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { accountInfoQueryKeys } from './queryKeys';
import type { AccountInfoResponse, CreateAccountInfoRequest } from './types';

export type CreateAccountInfoResponse = MusinsaStandardResponse<AccountInfoResponse>;

export interface CreateAccountInfoFormData {
  body: CreateAccountInfoRequest;
  bankAccountImage?: File | Blob;
  idCardImage?: File | Blob;
  businessRegistrationImage?: File | Blob;
}

/**
 * 정산정보 등록/수정
 * 큐레이터 정산정보를 등록하거나 수정합니다.
 * multipart/form-data로 전송됩니다.
 */
export const createAccountInfo = (data: CreateAccountInfoFormData) => {
  const formData = new FormData();

  const jsonBlob = new Blob([JSON.stringify(data.body)], {
    type: 'application/json',
  });
  formData.append('body', jsonBlob);
  if (data.bankAccountImage) {
    formData.append('bankAccountImage', data.bankAccountImage);
  }

  if (data.idCardImage) {
    formData.append('idCardImage', data.idCardImage);
  }

  if (data.businessRegistrationImage) {
    formData.append('businessRegistrationImage', data.businessRegistrationImage);
  }

  return executeStandardRequest(() =>
    privateHttpClient.post<CreateAccountInfoResponse>(
      accountInfoQueryKeys.createAccountInfo,
      formData as unknown as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    ),
  );
};
